import { render, staticRenderFns } from "./TableInvMovements.vue?vue&type=template&id=2f2b4cee&scoped=true"
import script from "./TableInvMovements.vue?vue&type=script&lang=js"
export * from "./TableInvMovements.vue?vue&type=script&lang=js"
import style0 from "./TableInvMovements.vue?vue&type=style&index=0&id=2f2b4cee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2b4cee",
  null
  
)

export default component.exports